import { TableRequestModel } from './tableRequestModel';

export const TableStateModel: TableRequestModel<string> = {
  filters: '',
  params: {
    page: 1,
    rowsPerPage: 25, // Matches CustomPagination options [10, 25, 50, 100]
    order: { name: null, direction: null },
  },
};
